import { useEffect, useState } from 'react';

/**
 * Trails `value` by `delay` milliseconds, resetting the timer on every change.
 *
 * Search boxes on this app's grids feed a query key directly, so without this
 * every keystroke is a request. `useServerDataGrid` documents its `search` input
 * as "already debounced by the caller" — this is what callers use.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
